module.exports = __webpack_public_path__ + "img/CasinoLoadingScreen.0706544b.jpg";